import { createAsyncThunk } from '@reduxjs/toolkit';
import { http } from 'app/fetch/fetcher';
import { abortControllers, AppDispatch } from 'app/store';
import { setError } from '../../../app/shared/appError/appErrorSlice';
import { fetchResource } from '../../../app/shared/utils/sliceUtils';
import {
  FullSearchResult,
  QuickSearchResult,
} from '../../models/api/searchModels';
import { getAPIBasedOnSystem } from 'DesignSystem/StyledComponets/Settings/SystemSwitch';

const searchApiUrl = 'api/search';
export let quickSearchAbortController = new AbortController();
export const fetchQuickSearchResult = createAsyncThunk(
  'search/quick-search',
  async (query: string, { dispatch }) => {
    const url = `${getAPIBasedOnSystem('cms')}/${searchApiUrl}/quick-search?query=${query}`;
    quickSearchAbortController = new AbortController();
    return http.handleHttpResponse<QuickSearchResult>(
      http.get<QuickSearchResult>(url, {
        signal: quickSearchAbortController.signal,
      }),
      dispatch,
      (err) => err?.data && dispatch(setError(err.data))
    );
  }
);

export const fetchSearchResult = (query: string, dispatch: AppDispatch) => {
  const url = `${getAPIBasedOnSystem('cms')}/${searchApiUrl}?${query}`;
  return http.handleHttpResponse<FullSearchResult>(
    http.get<FullSearchResult>(url),
    dispatch,
    (err) => err?.data && dispatch(setError(err.data))
  );
};

export const fetchSearchResultThunk = createAsyncThunk(
  'search/search',
  async (query: string, { dispatch }) => {
    const url = `${getAPIBasedOnSystem('cms')}/${searchApiUrl}?${query}`;
    return fetchResource<FullSearchResult>(
      url,
      dispatch,
      (err) => err && dispatch(setError(err))
    );
  }
);

export const fetchSuggestionResult = createAsyncThunk(
  'search/suggestions',
  async (query: string, { dispatch }) => {
    const url = `${getAPIBasedOnSystem('cms')}/${searchApiUrl}/suggestions?query=${query}`;
    const abortController = abortControllers.get('search/suggestions');
    return fetchResource<string[]>(
      url,
      dispatch,
      (err) => err && dispatch(setError(err)),
      {
        signal: abortController.signal,
      }
    );
  }
);
